import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function HRail({ title, icon: Icon, children, dark, empty }) {
  const ref = useRef(null);
  const scroll = (dir) => {
    if (ref.current) ref.current.scrollBy({ left: dir * (ref.current.clientWidth * 0.8), behavior: "smooth" });
  };
  const arrowCls = dark
    ? "bg-white/10 border border-white/20 text-white hover:bg-white/20"
    : "bg-white border-2 border-black text-black shadow-[2px_2px_0_0_#000] hover:-translate-y-0.5";
  return (
    <section className="space-y-2">
      <div className="flex items-center justify-between">
        <h2 className={`display text-lg font-bold flex items-center gap-2 ${dark ? "text-white" : ""}`}>
          {Icon && <Icon size={18} />} {title}
        </h2>
        <div className="hidden sm:flex gap-1.5">
          <button onClick={() => scroll(-1)} className={`w-8 h-8 grid place-items-center rounded-full transition-transform ${arrowCls}`} aria-label="scroll left"><ChevronLeft size={16} /></button>
          <button onClick={() => scroll(1)} className={`w-8 h-8 grid place-items-center rounded-full transition-transform ${arrowCls}`} aria-label="scroll right"><ChevronRight size={16} /></button>
        </div>
      </div>
      <div ref={ref} className="flex gap-3 overflow-x-auto pb-2 snap-x snap-mandatory no-scrollbar scroll-smooth">
        {children}
      </div>
      {empty}
    </section>
  );
}
